import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import authReducer from "./authReducer";
import camDoReducer from "./camDoReducer";
import quanLyChoVayReducer from "./quanLyChoVayReducer";
import quanLyThuChiReducer from "./quanLyThuChiReducer";
import { reducer as formReducer } from "redux-form";
import userReducer from "./userReducer";
import traGopReducer from "./traGopReducer";
import inChoVayReducer from "./inChoVayReducer";
import inLanDongLaiReducer from "./inLanDongLaiReducer";
import customerReducer from "./customerReducer";
import inThuChiReducer from "./inThuChiReducer";
import cauHinhReducer from "./cauHinhReducer";
import chiTietHopDongReducer from "./chiTietHopDongReducer";
import nophaithuReducer from "./nophaithuReducer";
import doiTinhTrangNoReducer from "./doiTinhTrangNoReducer";
import xoaHopDongReducer from "./xoaHopDongReducer";
import inMaVachTaiSanReducer from "./inMaVachTaiSanReducer";
import guiEmailReducer from "./guiEmailReducer";
import guiTinNhanReducer from "./guiTinNhanReducer";
import dongtiennhanhReducer from "./dongtiennhanhReducer";
import nhanVayReducer from "./nhanVayReducer";
import phiKhacReducer from "./phiKhacReducer";
import phiKhacHangKyReducer from "./phiKhacHangKyReducer";
import thuocTinhTaiSanReducer from "./thuocTinhTaiSanReducer";
import loaiTaiSanReducer from "./loaiTaiSanReducer";
import storeReducer from "./storeReducer";
import nguonKhachHangReducer from "./nguonKhachHangReducer";
import taiSanReducer from "./taiSanReducer";
import themMoiCamDoReducer from "./themMoiCamDoReducer";
import danhSachKhachHangReducer from "./danhSachKhachHangReducer";
import phanQuyenReducer from "./phanQuyenReducer";
import quanLyCuaHangReducer from "./quanLyCuaHangReducer";
import checkThongTinKhReducer from "./checkThongTinKhReducer";
import kiemTraNoXauReducer from "./kiemTraNoXauReducer";
import danhSachCuaHangReducer from "./danhSachCuaHangReducer";
import chiTietCuaHangReducer from "./chiTietCuaHangReducer";
import tongQuatCuaHangReducer from "./tongQuatCuaHangReducer";
import danhSachTaiSanReducer from "./danhSachTaiSanReducer";
import danhSachKhoReducer from "./danhSachKhoReducer";
// import danhSachThanhLyReducer from "./danhSachThanhLyReducer";
// import danhSachKiemKhoReducer from "./danhSachKiemKhoReducer";
// import kiemKhoReducer from "./kiemKhoReducer";
import danhSachNhanVienReducer from "./danhSachNhanVienReducer";
import quanLyCongViecReducer from "./quanLyCongViecReducer";
import thuChiHopDongReducer from "./thuChiHopDongReducer";

import tinChapReducer from "./tinChapReducer";
import themMoiTinChapReducer from "./themMoiTinChapReducer";
import menuReducer from "./menuReducer";
import giaHanNoPhaiThuReducer from "./giaHanNoPhaiThuReducer";
import ghiChuChoVayReducer from "./ghiChuChoVayReducer";
import thongBaoReducer from "./thongBaoReducer";
import themMoiTraGopReducer from "./themMoiTraGopReducer";
import addOrEditStoreReducer from "./addOrEditStoreReducer";
import deleteStoreReducer from "./deleteStoreReducer";
import thuChiNgoaiLeReducer from "./thuChiNgoaiLeReducer";
import thongKeThuReducer from "./thongKeThuReducer";

import daoHoReducer from "./daoHoReducer";

// import dataSearchNhanVay from "./NhanVay/dataSearchNhanVayReducer";
// import listNhanVayReducer from "./NhanVay/listNhanVayReducer";

//Nhận vay

//Nhận vay
import dataSearchNhanVayReducer from "./NhanVay/dataSearchNhanVayReducer";
import listNhanVayReducer from "./NhanVay/listNhanVayReducer";

import themMoiKhachHangReducer from "./themMoiKhachHangReducer";

import cuaHangDoiTacReducer from "./cuaHangDoiTacReducer";
import listTaiSanReducer from "./DanhSachTaiSan/listTaiSanReducer";
import dataSearchTaiSanReducer from "./DanhSachTaiSan/dataSearchTaiSanReducer";
//Danh Sách của hàng
import dataSearchCuaHangReducer from "./DanhSachCuaHang/dataSearchCuaHangReducer";
import listCuaHangReducer from "./DanhSachCuaHang/listCuaHangReducer";
import addAndEditCuaHangReducer from "./DanhSachCuaHang/addAndEditCuaHangReducer";
//End danh sách cửa hàng

//Dư nợ cho vay
import listDuNoChoVayReducer from "./DuNoChoVay/listDuNoChoVayReducer";
import dataSearchDuNoChoVayReducer from "./DuNoChoVay/dataSearchDuNoChoVayReducer";

//Dư Nợ Nhận vay
import listDuNoNhanVayReducer from "./DuNoNhanVay/listDuNoNhanVayReducer";
import dataSearchDuNoNhanVayReducer from "./DuNoNhanVay/dataSearchDuNoNhanVayReducer";

//Dư Nợ Giao Nhân Viên
import listDuNoGiaoNhanVienReducer from "./DuNoGiaoNhanVien/listDuNoGiaoNhanVienReducer";
import dataSearchDuNoGiaoNhanVienReducer from "./DuNoGiaoNhanVien/dataSearchDuNoGiaoNhanVienReducer";

//Danh sách hợp đồng bị xoá
import listHopDongDeleteReducer from "./DanhSachHopDongDelete/listHopDongDeleteReducer";
import dataSearchHopDongDeleteReducer from "./DanhSachHopDongDelete/dataSearchHopDongDeleteReducer";

//Danh sách thu bị xoá
import listThuDeleteReducer from "./DanhSachThuDelete/listThuDeleteReducer";
import dataSearchThuDeleteReducer from "./DanhSachThuDelete/dataSearchThuDeleteReducer";

//Danh sách chi bị xoá
import listChiDeleteReducer from "./DanhSachChiDelete/listChiDeleteReducer";
import dataSearchChiDeleteReducer from "./DanhSachChiDelete/dataSearchChiDeleteReducer";

//Công nợ thanh lý
import listCongNoThanhLyReducer from "./CongNoThanhLy/listCongNoThanhLyReducer";
import dataSearchCongNoThanhLyReducer from "./CongNoThanhLy/dataSearchCongNoThanhLyReducer";

//Danh sách hợp đồng chờ duyệt
import listHopDongChoDuyetReducer from "./DanhSachHopDongChoDuyet/listHopDongChoDuyetReducer";
import dataSearchHopDongChoDuyetReducer from "./DanhSachHopDongChoDuyet/dataSearchHopDongChoDuyetReducer";

//Danh sách Kiểm kho
import listDanhSachKiemKhoReducer from "./DanhSachKiemKho/listDanhSachKiemKhoReducer";
import dataSearchDanhSachKiemKhoReducer from "./DanhSachKiemKho/dataSearchDanhSachKiemKhoReducer";

//Danh sách Ticket
import listDanhSachTicketReducer from "./DanhSachTicket/listDanhSachTicketReducer";
import dataSearchDanhSachTicketReducer from "./DanhSachTicket/dataSearchDanhSachTicketReducer";

//Danh sách thanh lý
import listDanhSachThanhLyReducer from "./DanhSachThanhLy/listDanhSachThanhLyReducer";
import dataSearchDanhSachThanhLyReducer from "./DanhSachThanhLy/dataSearchDanhSachThanhLyReducer";

//Kiểm kho
import listKiemKhoReducer from "./KiemKho/listKiemKhoReducer";
import dataSearchKiemKhoReducer from "./KiemKho/dataSearchKiemKhoReducer";

//Ticket
import listTicketReducer from "./Ticket/listTicketReducer";
import dataSearchTicketReducer from "./Ticket/dataSearchTicketReducer";

import inNhanVayReducer from "./inNhanVayReducer";

//Quản lý thu chi hợp đồng
import listQuanLyThuChiHopDongReducer from "./QuanLyThuChiHopDong/listQuanLyThuChiHopDongReducer";
import dataSearchQuanLyThuChiHopDongReducer from "./QuanLyThuChiHopDong/dataSearchQuanLyThuChiHopDongReducer";

//Quản lý thu chi ngoài lề
import listQuanLyThuChiNgoaiLeReducer from "./QuanLyThuChiNgoaiLe/listQuanLyThuChiNgoaiLeReducer";
import dataSearchQuanLyThuChiNgoaiLeReducer from "./QuanLyThuChiNgoaiLe/dataSearchQuanLyThuChiNgoaiLeReducer";

//Nguồn vốn
import listNguonVonReducer from "./NguonVon/listNguonVonReducer";
import dataSearchNguonVonReducer from "./NguonVon/dataSearchNguonVonReducer";
import danhSachThongTinVayReducer from "./ChoThongTinVay/danhSachThongTinVayReducer";

//Bán hàng trả góp
import banHangTraGopReducer from "./BanHangTraGop/banHangTraGopReducer";
import themMoiBanHangTraGopReducer from "./BanHangTraGop/themMoiBanHangTraGopReducer";
import dataSearchCauHinhGoiTraGopReducer from "./QuanTriHeThong/CauHinhGoiTraGop/dataSearchCauHinhGoiTraGopReducer";
import listCauHinhGoiTraGopReducer from "./QuanTriHeThong/CauHinhGoiTraGop/listCauHinhGoiTraGopReducer";
import dataSearchTaiKhoanBankReducer from "./TichHopBank/DanhSachTaiKhoanBank/dataSearchTaiKhoanBankReducer";
import dataSearchLichSuBankReducer from "./TichHopBank/DanhSachTaiKhoanBank/dataSearchLichSuBankReducer";
import dataSearchChoThanhToanReducer from "./TichHopBank/DanhSachTaiKhoanBank/dataSearchChoThanhToanReducer";
import dataSearchGoiVayReducer from "./GoiVay/dataSearchGoiVayReducer";
import dataSearchTatToanChoDuyet from "./DanhSachTatToanChoDuyet/dataSearchTatToanChoDuyetReducer";
import dataSearchTaiKhoanIcloud from "./QuanTriHeThong/dataSearchTaiKhoanIcloudReducer";


const appReducer = combineReducers({
  routing: routerReducer,
  auth: authReducer,
  camdo: camDoReducer,
  user: userReducer,
  quanlychovay: quanLyChoVayReducer,
  quanlythuchi: quanLyThuChiReducer,
  form: formReducer,
  tragop: traGopReducer,
  inchovay: inChoVayReducer,
  inlandonglai: inLanDongLaiReducer,
  customer: customerReducer,
  inthuchi: inThuChiReducer,
  cauhinh: cauHinhReducer,
  chitiethopdong: chiTietHopDongReducer,
  nophaithu: nophaithuReducer,
  doitinhtrangno: doiTinhTrangNoReducer,
  xoahopdong: xoaHopDongReducer,
  inmavachtaisan: inMaVachTaiSanReducer,
  guiemail: guiEmailReducer,
  guitinnhan: guiTinNhanReducer,
  dongtiennhanh: dongtiennhanhReducer,
  nhanvay: nhanVayReducer,
  phikhac: phiKhacReducer,
  phikhachangky: phiKhacHangKyReducer,
  thuoctinhtaisan: thuocTinhTaiSanReducer,
  loaitaisan: loaiTaiSanReducer,
  store: storeReducer,
  nguonkhachhang: nguonKhachHangReducer,
  taisan: taiSanReducer,
  themmoicamdo: themMoiCamDoReducer,
  danhsachkhachhang: danhSachKhachHangReducer,
  phanquyen: phanQuyenReducer,
  quanlycuahang: quanLyCuaHangReducer,
  checkthongtinkh: checkThongTinKhReducer,
  tinchap: tinChapReducer,
  themmoitinchap: themMoiTinChapReducer,
  kiemtranoxau: kiemTraNoXauReducer,
  menu: menuReducer,
  danhsachcuahang: danhSachCuaHangReducer,
  tongquatcuahang: tongQuatCuaHangReducer,
  chitietcuahang: chiTietCuaHangReducer,
  danhsachtaisan: danhSachTaiSanReducer,
  giahannophaithu: giaHanNoPhaiThuReducer,
  ghichuchovay: ghiChuChoVayReducer,
  danhsachkho: danhSachKhoReducer,
  // danhsachthanhly: danhSachThanhLyReducer,
  // danhsachkiemkho: danhSachKiemKhoReducer,
  // kiemkho: kiemKhoReducer,
  danhsachnhanvien: danhSachNhanVienReducer,
  quanlycongviec: quanLyCongViecReducer,
  thongbao: thongBaoReducer,
  thuchihopdong: thuChiHopDongReducer,
  themmoitragop: themMoiTraGopReducer,
  thuchingoaile: thuChiNgoaiLeReducer,
  addoreditstore: addOrEditStoreReducer,
  deletestore: deleteStoreReducer,
  thongkethu: thongKeThuReducer,
  daoho: daoHoReducer,
  themmoikhachhang: themMoiKhachHangReducer,
  cuahangdoitac: cuaHangDoiTacReducer,
  // listNhanVay: listNhanVayReducer,
  // dataSearchNhanVay: dataSearchNhanVay,
  //Nhận vay
  listNhanVay: listNhanVayReducer,
  dataSearchNhanVay: dataSearchNhanVayReducer,
  //End
  listTaiSanFull: listTaiSanReducer,
  dataSearchTaiSan: dataSearchTaiSanReducer,
  //Danh Sách của hàng
  dataSearchCuaHang: dataSearchCuaHangReducer,
  listCuaHang: listCuaHangReducer,
  addAndEditCuaHang: addAndEditCuaHangReducer,
  //end danh sách cửa hàng
  //Dư Nợ cho vay
  listDuNoChoVayFull: listDuNoChoVayReducer,
  dataSearchDuNoChoVay: dataSearchDuNoChoVayReducer,

  //Dư Nợ Nhận vay
  listDuNoNhanVayFull: listDuNoNhanVayReducer,
  dataSearchDuNoNhanVay: dataSearchDuNoNhanVayReducer,

  //Dư Nợ Giao Nhân Viên
  listDuNoGiaoNhanVienFull: listDuNoGiaoNhanVienReducer,
  dataSearchDuNoGiaoNhanVien: dataSearchDuNoGiaoNhanVienReducer,

  //Danh sách hợp đồng bị xoá
  listDanhSachHopDongDeleteFull: listHopDongDeleteReducer,
  dataSearchHopDongDelete: dataSearchHopDongDeleteReducer,

  //Danh sách thu bị xoá
  listDanhSachThuDeleteFull: listThuDeleteReducer,
  dataSearchThuDelete: dataSearchThuDeleteReducer,

  //Danh sách chi bị xoá
  listDanhSachChiDeleteFull: listChiDeleteReducer,
  dataSearchChiDelete: dataSearchChiDeleteReducer,

  //Công nợ thanh lý
  listCongNoThanhLyFull: listCongNoThanhLyReducer,
  dataSearchCongNoThanhLy: dataSearchCongNoThanhLyReducer,

  //Danh sách hợp đồng chờ duyệt
  listHopDongChoDuyetFull: listHopDongChoDuyetReducer,
  dataSearchHopDongChoDuyet: dataSearchHopDongChoDuyetReducer,

  //Danh sách Kiểm kho
  listDanhSachKiemKhoFull: listDanhSachKiemKhoReducer,
  dataSearchDanhSachKiemKho: dataSearchDanhSachKiemKhoReducer,

  //Danh sách thanh lý
  listDanhSachThanhLyFull: listDanhSachThanhLyReducer,
  dataSearchDanhSachThanhLy: dataSearchDanhSachThanhLyReducer,

  //Kiểm kho
  listKiemKhoFull: listKiemKhoReducer,
  dataSearchKiemKho: dataSearchKiemKhoReducer,

  //Ticket
  listTicketFull: listTicketReducer,
  dataSearchTicket: dataSearchTicketReducer,

  //in hợp đồng nhận vay
  inNhanVay: inNhanVayReducer,

  //Quản lý thu chi hợp đồng
  listQuanLyThuChiHopDongFull: listQuanLyThuChiHopDongReducer,
  dataSearchQuanLyThuChiHopDong: dataSearchQuanLyThuChiHopDongReducer,

  //Quản lý thu chi ngoài lề
  listQuanLyThuChiNgoaiLeFull: listQuanLyThuChiNgoaiLeReducer,
  dataSearchQuanLyThuChiNgoaiLe: dataSearchQuanLyThuChiNgoaiLeReducer,

  //Nguồn vốn
  listNguonVonFull: listNguonVonReducer,
  dataSearchNguonVon: dataSearchNguonVonReducer,
  danhSachThongTinVay: danhSachThongTinVayReducer,

  //Bán hàng trả góp
  banHangTraGop: banHangTraGopReducer,
  themMoiBanHangTraGop: themMoiBanHangTraGopReducer,

  //Cấu hình gói trả góp
  listCauHinhGoiTraGop: listCauHinhGoiTraGopReducer,
  dataSearchCauHinhGoiTraGop: dataSearchCauHinhGoiTraGopReducer,
  dataSearchTaiKhoanBank: dataSearchTaiKhoanBankReducer,
  dataSearchLichSuBank: dataSearchLichSuBankReducer,
  dataSearchChoThanhToan: dataSearchChoThanhToanReducer,

  dataSearchGoiVay: dataSearchGoiVayReducer,
  dataSearchTatToanChoDuyet: dataSearchTatToanChoDuyet,
  dataSearchTaiKhoanIcloud: dataSearchTaiKhoanIcloud,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_ALL_DATA") {
    state = {
      auth: state.auth,
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
